import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingCallButton from "./components/FloatingCallButton";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import DesignMyWall from "./pages/DesignMyWall";
import Locations from "./pages/Locations";
import City from "./pages/City";
import ServicesHub from "./pages/ServicesHub";
import ServicePage from "./pages/ServicePage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { useLocation } from "react-router-dom";

function Chrome({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Header />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
      {!isAdmin && <FloatingCallButton />}
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App min-h-screen bg-[#050505] text-white">
          <Chrome>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/design-my-wall" element={<DesignMyWall />} />
              <Route path="/locations" element={<Locations />} />
              <Route path="/locations/:city" element={<City />} />
              <Route path="/services" element={<ServicesHub />} />
              <Route path="/services/:service" element={<ServicePage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Chrome>
          <Toaster
            position="top-center"
            theme="dark"
            toastOptions={{
              style: { background: "#111111", border: "1px solid #27272A", color: "#ffffff" },
            }}
          />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
